const rutasProyectoTorre1 = [

  // torre_1
  // torre_1_p1
  // torre_1_pisos
  // torre_1_ventanas
  // torre_1_balconesMuros
  // torre_1_balconesBarandas * tiene Alpha

  /// Modelos
  {
    name: "modelo_torre_1",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE 01.gltf",
  },
  {
    name: "modelo_torre_1_cubierta",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE 01_PISOS Y CUARTOS CUBIERTA.gltf",
  },
  {
    name: "modelo_torre_1_barandas",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/TORRE 01_BALCONES_BARANDAS.gltf",
  },
  {
    name: "modelo_torre_1_rejilla",
    type: "gltfModel",
    path: "modelos/proyecto/nuevo/REJILLA.gltf",
  },
  
  ///Texturas  
  /*{
    name: "text_ejemplo",
    type: "texture",
    path: "texturas/proyecto/ejemplo.webp"
  },*/

  {
    name: "text_torre_1",
    type: "texture",
    path: "texturas/proyecto/nuevo/TORRE 01_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_cubierta",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_TORRE 01_PISOS Y CUARTOS CUBIERTA_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_barandas",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_TORRE 01_BALCONES_BARANDAS_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_barandas_alpha",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_TORRE 01_BALCONES_BARANDAS_ALPHA.webp"
  },
  {
    name: "text_torre_1_rejilla",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_REJILLA_Corona_Diffuse.webp"
  },
  {
    name: "text_torre_1_rejilla_alpha",
    type: "texture",
    path: "texturas/proyecto/nuevo/FL_REJILLA_ALPHA.webp"
  },
];

export default rutasProyectoTorre1;
